import MUIDataTable from 'mui-datatables';
import React from 'react';
import { Localizacion } from 'lib.front';
import { createTheme, ThemeProvider } from '@mui/material';

const options = {
    filterType: 'dropdown',
    selectableRows: 'none',
    responsive: 'standard',
    pagination: true,
    searchOpen: true,
    search: true,
    elevation: 0,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 15, 100],
    rowHover: false,
    print: false,
    download: false,
    viewColumns: true,
    filter: true,
    textLabels: Localizacion.muiDataTables.ES
};

const getMuiThemeDataTable = () =>
    createTheme({
        components: {
            MUIDataTable: {
                styleOverrides: {
                    responsiveBase: {
                        border: '1px solid #200505ff',
                        borderRadius: '10px',
                        borderCollapse: 'separate'
                    }
                }
            },
            MUIDataTableHeadCell: {
                styleOverrides: {
                    root: {
                        color: '#7B2CBF'
                    }
                }
            }
        }
    });

export const MuiDataTable = ({ columns, data }) => {
    return (
        <ThemeProvider theme={getMuiThemeDataTable()}>
            <MUIDataTable columns={columns} data={data} options={options} />
        </ThemeProvider>
    );
};
